import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as FilterIcon } from "../../../assets/svg/filters-blue.svg";

import { setActiveModule } from "../../../actions/sideBarActions";

const SMRFilters = () => {
    const dispatch = useDispatch();
    // useEffect(() => {
    //     let obj = {
    //         // total_sections: 33,
    //         progress_config: {
    //             smr_filters: 1,
    //         },
    //     };

    //     dispatch(configure_getting_started_progress(obj));
    // }, []);
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                smr_filters: 1,
            },
        };
        localStorage.setItem("activeModule", "Response");
        dispatch(setActiveModule("Response"));
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <FilterIcon className="icon_content" />
                        <span className="content_title">Response Filters</span>
                    </div>
                    <div className="text_content">
                        <p>{`You can use SMR filters to decide if all messages fetched for your accounts should be visible in the SMR Inbox or if they should pass
                        through additional filters.`}</p>
                        <p>
                            SMR filters, if configured, will be applied on your messages and any messages that do not match the filters will not be visible in
                            the SMR Inbox.
                        </p>
                        <p>
                            {` This functionality is useful if you only want to respond to some messages based on pre-configured
                        rules. The filters do not apply to Direct Messages (DM's) and they will always be visible in the SMR Inbox.`}
                        </p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to="/social-response/filters">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/POGtNLaT9Xk"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default SMRFilters;
